import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  staging: true,
  APP_SERVICES_URL: 'https://api.staging1.machool.com/REST-app-services/api/v1',
  ESPRESSO_URL: 'https://espresso.staging1.machool.com',
  INTEGRATION_SERVICES_URL: 'https://api.staging1.machool.com/REST-integration-services/api/v1',
  UTILITY_SERVICES_URL: 'https://api.staging1.machool.com/REST-utility-services/api/v1',
  TIMESERIES_SERVICES_URL: 'https://api.staging1.machool.com/REST-timeseries-services/api/v1',
  firebaseTenantID: 'staging1-admin-panel-f2une',
};

export const environment = Object.assign(commonEnv, env);
